// Connects the AnalysisLayout's "Save and close" button to whatever the
// current defo page wants to do on save. Each page registers a handler
// via `setSaveHandler(async () => { ... })` in an effect; the layout
// awaits the handler and only then calls `window.close()`.
//
// If no handler is registered, the button still works — it just closes
// the tab without an API round-trip (early-Run cases where nothing has
// been computed yet).

import React, { createContext, useCallback, useContext, useRef, useState } from 'react';

const Ctx = createContext({
  setSaveHandler: () => {},
  triggerSave: async () => {},
  saving: false,
  hasSaveHandler: false,
});

export function AnalysisActionsProvider({ children }) {
  const handlerRef = useRef(null);
  const [hasSaveHandler, setHas] = useState(false);
  const [saving, setSaving] = useState(false);

  const setSaveHandler = useCallback((fn) => {
    handlerRef.current = fn || null;
    setHas(!!fn);
  }, []);

  const triggerSave = useCallback(async () => {
    const fn = handlerRef.current;
    if (!fn) return;
    setSaving(true);
    try {
      await fn();
    } finally {
      setSaving(false);
    }
  }, []);

  return (
    <Ctx.Provider value={{ setSaveHandler, triggerSave, saving, hasSaveHandler }}>
      {children}
    </Ctx.Provider>
  );
}

export function useAnalysisActions() {
  return useContext(Ctx);
}
